import type { ApplyClaimState } from '@/types/store/applyClaim';
import { defineStore } from 'pinia';
// 存储全局状态
export default defineStore('applyClaim', {
  state: (): ApplyClaimState => {
    return {
      checkToken1: '', // 用于理赔页面的
      appluClaimWaybillNo: '', // 缓存理赔单号
    };
  },
  actions: {
    setCheckToken1(checkToken1: string) {
      this.checkToken1 = checkToken1;
    },
    setAppluClaimWaybillNo(waybillNo: string) {
      this.appluClaimWaybillNo = waybillNo;
    },
  },
  getters: {},
});
